<template>
  <footer class="bg-footer w-full px-2 py-4 flex flex-col items-center">
    <section class="flex flex-col items-center lg:flex-row lg:justify-between lg:w-lg lg:px-4">
      <img
        src="/image/resource/white_brand.png"
        class="w-32 h-11 lg:w-36 lg:h-12 mb-4 -ml-4 lg:mt-6 lg:order-2"
      />
      <section class="flex flex-col items-center lg:items-start">
        <p class="lg:text-left text-white text-2xl font-black">
          POLÍTICA DE PRIVACIDAD
        </p>
        <p class="lg:text-left text-white mt-1 text-center">
          Condiciones legales
        </p>
        <p class="lg:text-left text-white mt-1 text-center">
          Politica de privacidad
        </p>
        <p class="lg:text-left text-white mt-1 text-center">
          Politica de cookies
        </p>
        <p class="lg:text-left text-white mt-1 text-center">
          Politica de redes sociales
        </p>
      </section>
    </section>
    <div class="w-full border-b border-white my-4" />
    <section>
      <p class="text-white text-center">ECUADOR - (+593) 98 206 2988</p>
      <section class="flex justify-center items-center my-2">
        <a target="_blank" href="mailto:info@saludelearning.com">
          <icon-mail coloricon="#fff" style="transform: scale(0.8);" />
        </a>
        <a target="_blank" href="https://www.instagram.com/saludelearning/">
          <icon-instagram
            class="mx-8"
            coloricon="#fff"
            style="transform: scale(0.8);"
          />
        </a>
        <a target="_blank" href="https://www.facebook.com/saludelearning">
          <icon-facebook coloricon="#fff" style="transform: scale(0.8);" />
        </a>
      </section>
      <p class="text-white text-sm text-center">
        Copyright © Salud E-learning 2020 -Todos los derechos reservados, Desarrollado por Amoba Software.
      </p>
    </section>
  </footer>
</template>
<script>
// import { mapGetters } from "vuex";
import iconFacebook from "../../../v2/src/components/icons/Facebook";
import iconInstagram from "../../../v2/src/components/icons/Instagram";
import iconMail from "../../../v2/src/components/icons/Mail";

export default {
  components: {
    iconFacebook,
    iconInstagram,
    iconMail,
  },
  data: () => ({
    selectedSection: false,
  }),
};
</script>
<style scoped>
.bg-footer {
  background-image: url("/image/resource/footer.jpg");
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
